import { get, post } from '../Services/http';
import { catchError } from './Error.action';

export const LOADING_DATE_PICKER_LOAD = 'LOADING_DATE_PICKER_LOAD';
export const LOADING_DATE_PICKER_LOAD_ERROR = 'LOADING_DATE_PICKER_LOAD_ERROR';
export const LOADING_DATE_PICKER_RECEIVE = 'LOADING_DATE_PICKER_RECEIVE';
export const LOADING_DATE_PICKER_TOGGLE = 'LOADING_DATE_PICKER_TOGGLE';

const rootRoute = '/api/loadingdate/';

export const getLoadingDate = () => (dispatch, getState) => {
 
    return get(rootRoute + 'getLoadingDate')
        .then(response => response.json())
        .then(response => dispatch(receive(response)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
}

export const setLoadingDate = (date) => (dispatch, getState) => {
    
    return post(rootRoute + 'setLoadingDate', {date : date})
        .then(response => response.json())
        .then(response => dispatch(receive(response)))
        .then(response => dispatch(show(false)))
        .then(response => location.reload())
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
}

export const togglePicker = () => (dispatch, getState) => {
    dispatch(show(!getState().loadingDatePicker.showPicker));
}

export const showList = (list) => (dispatch, getState) => {
    return list;
}

export const loadError = error => ({
    type: LOADING_DATE_PICKER_LOAD_ERROR,
    payload: {
        error,
    }
})


const show = visible => ({
    type: LOADING_DATE_PICKER_TOGGLE,
    payload: {
        showPicker: visible,
    }
})


export const receive = data => {
    return ({
        type: LOADING_DATE_PICKER_RECEIVE,
        payload: {
            loadingDateObject: data,
        }
    });
}